import flow from "lodash/flow";
import diacritics from "diacritics";
import slugify from "slugify";
import kebabCase from "lodash/kebabCase";
import stripAccents from "./stripAccents";

const removeDiacritics = diacritics.remove;

const replaceApostrophes = (str) => (str || "").replace(/[’ʻʼ]/g, "-");

const cleanString = flow([
  replaceApostrophes,
  kebabCase,
  stripAccents,
  removeDiacritics,
  slugify,
]);

export default cleanString;



// WEBPACK FOOTER //
// ../server/lib/cleanString.js